import { withStyles, WithStyles } from '@material-ui/core'
import i18n from 'i18next'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
    // confirmBeforeLoginApartment,
    instantRentStepCLick,
    saveInstantRentApplicationInfo,
    stepAfterShowingBack,
    stepAfterShowingForward
} from '../../actions/apartments'
//import { saveInstantRentUserInfo } from '../../actions/applications'
import { navigate } from '../../actions/routes'
import { Navigate, InstantRentApplicationFormAction } from '../../actions/types'
// import Banner from '../../components/Banner/Banner'
import Container from '../../components/Container'
import { selectApartmentById } from '../../selectors/apartments'
import { selectContentIdFromPathname } from '../../selectors/router'
import { selectIsMobile } from '../../selectors/users'
import { apartmentStyles } from '../../styles'
import { MuiClasses } from '../../types'
import { BeforeLoginApartment } from '../../types/apartments'
import { StateInterface } from '../../types/states'
import { bindSubmitActionToPromise } from '../../utils/forms'
import NewApplicationProgress from './Progress'
import { AfterShowingSteps } from '../AfterShowing/Steps'

type ParamsProps = {
    step: number
}

interface MatchProps {
    params: ParamsProps
}

interface PropsFromState {
    apartment?: BeforeLoginApartment | undefined
    isMobile: unknown
}

interface DispatchProps {
    doNavigate: Navigate
    doStepBack: () => void
    doStepForward: () => void
    doStepClick: (step: number) => any
    saveInstantRent: InstantRentApplicationFormAction
}

interface OwnProps {
    match: MatchProps
    t: i18n.TFunction
    classes: MuiClasses
}

export interface AfterShowingStepperProps
    extends OwnProps,
    DispatchProps,
    PropsFromState,
    WithTranslation,
    WithStyles { }

export interface AfterShowingStepProps extends AfterShowingStepperProps {
    currentStep: number
    beforeLogin: boolean
    isMobile: any
}

const AfterShowingStepper = (
    stepperProps: AfterShowingStepperProps
) => {
    const {
        match: {
            params: { step }
        },
        classes,
        isMobile,
        doStepBack
    } = stepperProps
    const currentStep = Number(step)
    const afterShowingStepProps: AfterShowingStepProps = {
        ...stepperProps,
        currentStep,
        classes,
        beforeLogin: true,
        isMobile,
        doStepBack
    }

    return (
        <>
            {/* {currentStep !== 1 && currentStep !== 8 && (
        <Banner message={i18n.t('instantRent.timeOutNotice')} />
      )} */}
            {currentStep !== 0 && (
                <Container
                    //styles={{ maxWidth: '1221px', margin: 'auto', padding: '8px 40px' }}
                    styles={{ maxWidth: '1131px', margin: 'auto', padding: '8px 40px' }}
                >
                    <NewApplicationProgress
                        currentStep={currentStep}
                        progress={(currentStep / 3) * 100}
                        updateType
                    />
                </Container>
            )}
            <AfterShowingSteps {...afterShowingStepProps} />
        </>
    )
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    saveInstantRent: bindSubmitActionToPromise(
        dispatch,
        saveInstantRentApplicationInfo
    ),
    //saveUserInfo: bindSubmitActionToPromise(dispatch, saveInstantRentUserInfo),
    doStepBack: () => dispatch(stepAfterShowingBack({ beforeLogin: true })),
    doStepForward: () => dispatch(stepAfterShowingForward({ beforeLogin: true })),
    doNavigate: (toPath: string) => dispatch(navigate(toPath)),
    doStepClick: (step: number) =>
        dispatch(instantRentStepCLick({ step, beforeLogin: true }))
})

const mapStateToProps = (state: StateInterface): PropsFromState => {
    const apartmentId = selectContentIdFromPathname(state)
    const apartment = apartmentId
        ? selectApartmentById(apartmentId)(state)
        : undefined
    return {
        apartment,
        isMobile: selectIsMobile(state)
    }
}

export default connect<PropsFromState, DispatchProps, OwnProps, StateInterface>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(apartmentStyles)(withTranslation()(AfterShowingStepper)))
